import {Alert, Modal} from "antd";
import React, {useEffect, useState} from "react";
import Subscription from "../../pages/subscription/Subscription";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

export default (props) => {
    const [open, setOpen] = useState(false)
    const breakPoints = useBreakpoint()

    useEffect(() => {
        setOpen(props.open)
    }, [props.open])

    let width = '80vw'

    if (breakPoints && breakPoints.xs) {
        width = '95vw'
    }

    return (
        <Modal title={<span style={{fontSize: 14, color: 'grey'}}>Upgrade a plan / <span
            style={{fontSize: 14, color: 'black'}}>Pick a plan</span></span>}
               closeIcon={<></>} centered open={open} onCancel={props.onClose} footer={null} width={width}>
            <div style={{overflowY: 'auto', maxHeight: '80vh', overflowX: 'hidden'}}>
                {props.isUpgrade && (
                      <Alert
                          message="Upgrade Your Plan"
                          description="To access this feature, please consider upgrading your current plan."
                          type="info"
                          showIcon
                        />
                )}
                <Subscription onSubscriptionChanged={props.onSubscriptionChanged}/>
                <center>
                    <a style={{display: 'block', color: 'black', textDecoration: 'underline'}} onClick={props.logout}>
                        Logout and switch to another user
                    </a>
                </center>
            </div>
        </Modal>
    )
}